class ScrollReveal {
  constructor(el) {
    this.el = el;
    this.initialize();
  }

  initialize() {
    this.bindSetttings();
    this.bindObserver();
  }

  bindSetttings() {
    this.observer = null;
    this.options = {
      rootMargin: '0px',
      threshold: 0,
    };
  }

  bindObserver() {
    this.observer = new IntersectionObserver(this.observerCallback, this.options);
    this.observer.observe(this.el);
  }

  observerCallback(entries) {
    entries.forEach((entry) => {
      const delay = entry.target.getAttribute('animate-delay') || 50;

      if (entry.isIntersecting) {
        setTimeout(() => {
          entry.target.classList.add('isVisible');
        }, delay);
      }
    });
  }
}
export default ScrollReveal;
